export default "__VITE_ASSET__88348c32__"